<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useThemeSync } from '@/composables/useTheme'

useThemeSync()
</script>

<template>
  <el-config-provider size="large">
    <RouterView />
  </el-config-provider>
</template>
